// src/api/adminReferrals.ts
import axios from '../api/axios';

export type ReferralRow = {
  id: number;
  referrer_id: number;
  referred_email: string | null;
  referred_user_id: number | null;
  status: 'pending' | 'completed' | 'canceled';
  created_at: string;
  completed_at?: string | null;
  referred_has_paid: boolean;
  first_paid_at?: string | null;
  commission_total?: number;
};

export type ReferralConfig = {
  referrer_coupon_id: number;
  referred_coupon_id: number;
  referrer_coupon?: {
    id: number;
    name?: string | null;
    code?: string | null;
    discount_type?: 'percent' | 'amount' | 'fixed_price' | null;
    discount_value?: number | null;
    is_active?: boolean;
    starts_at?: string | null;
    ends_at?: string | null;
  } | null;
  referred_coupon?: {
    id: number;
    name?: string | null;
    code?: string | null;
    discount_type?: 'percent' | 'amount' | 'fixed_price' | null;
    discount_value?: number | null;
    is_active?: boolean;
    starts_at?: string | null;
    ends_at?: string | null;
  } | null;
  // 予約コード（この2つのコードを持つ『有効な』クーポンが自動採用される）
  referrer_code?: string;
  referred_code?: string;
  // 現在の取得元: 'code'（予約コード一致で自動採用）/ 'env'（フォールバック）/ 'unset'（該当なし）
  referrer_source?: 'code' | 'env' | 'unset';
  referred_source?: 'code' | 'env' | 'unset';
  note?: string;
};

export type ListParams = {
  q?: string;
  status?: 'pending' | 'completed' | 'canceled';
  order_by?: 'id' | 'created_at' | 'completed_at' | 'status';
  order_dir?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
};

export async function fetchReferralConfig(): Promise<ReferralConfig> {
  const r = await axios.get<ReferralConfig>('/admin/referrals/config');
  return r.data;
}

export async function fetchReferrals(params: ListParams): Promise<ReferralRow[]> {
  const r = await axios.get<ReferralRow[]>('/admin/referrals', { params });
  return r.data;
}

export type ReferralGroupChild = {
  user_id: number | null;
  email: string | null;
  name: string | null;
  member_type: 'employee' | 'family' | 'friend' | null;
  status: 'pending' | 'completed' | 'canceled';
  created_at: string;
};

export type ReferralGroup = {
  referrer_id: number;
  referrer_name: string | null;
  referrer_email: string | null;
  referrer_member_type: 'employee' | 'family' | 'friend' | null;
  company_name: string | null;
  referred: ReferralGroupChild[];
  referred_count: number;
  family_count: number;
  friend_count: number;
};

export async function fetchReferralGroups(q?: string): Promise<ReferralGroup[]> {
  const r = await axios.get<ReferralGroup[]>('/admin/referrals/groups', {
    params: q ? { q } : undefined,
  });
  return r.data;
}

export async function completeReferral(
  referralId: number,
  payload: { referred_user_id: number; referrer_coupon_id: number; referred_coupon_id: number }
): Promise<{ ok: boolean }> {
  const r = await axios.post<{ ok: boolean }>(`/admin/referrals/${referralId}/complete`, payload);
  return r.data;
}
